import './Patients.css'
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import DashHeader from '../../../Component/sections/DashHeader/DashHeader'
import Table from '../../../Component/custom/Table/Table';
import Modal from '../../../Component/custom/Modal/Modal.jsx'
import TwoInputs from '../../../Component/common/TwoInputs/TwoInputs';
import {toast , ToastContainer} from 'react-toastify'
import getData from '../../../utils/getData';
function Patients(){
  const { t } = useTranslation();

  const nav = useNavigate()
  const [addModal , setAddModal] = useState(false)
  const [ patients , setPaitents] = useState([])
  const [ loader , setLoader] = useState(false)

  const [searchValue , setSearchValue] = useState("")

  const getSearchValue = (e)=>{
    setSearchValue(e.target.value)
  }

  const getUsers = async()=>{
    setLoader(true)
    try{
      const res = await getData("user")
      setPaitents(res?.data?.data)
    }
    finally{
      setLoader(false)
    }
  }

  useEffect(()=>{
    getUsers()
  },[])
  const AddPaitent = ()=>{
    setAddModal(false)
    toast.success(t('patientAdded'))
  }

  return (
    <div className='patients-container'>
      <div className='patients-content'>
        <ToastContainer/>
        <DashHeader header={t('patients')} btnFn={()=>setAddModal(true)}  getSearchValue = {getSearchValue}/>
        <Table
          searchValue={searchValue}
          loader={loader}
          headers={[
            t('name'),
            t('email'),
            t('age'),
            t('mobile'),
            t('gender'),
            t('visits'),
            t('lastVisits'),
            t('actions'),
          ]}
          keys={["first_name", "email" , "age", "phone", "gender", "visitsCount"]}
          data={patients}
          renderAction={(item) => (
            <>
            <td>
                {new Date(item.updated_at).toLocaleDateString()}
            </td>
            <td>
              <button
                className='detailsBtn'
                onClick={() => nav(`/patients/${item.first_name}`, {state: item})}
                >
                {t('moreDetails')}
              </button>
            </td>
                </>
          )}
        />
        <Modal isOpen={addModal} showModalsBtns={true} AcceptBtn={t('add')} handleAdd={AddPaitent} CancelBtn={t('cancel')} handleCancel={()=>setAddModal(false)}>
          <h3>{t('addNewPatient')}</h3>
         <div className="inputs">
           <TwoInputs
            typeOne={"text"}
            typeTwo={"number"}
            placeOne={t('enterName')}
            placeTwo={t('enterAge')}
           />
           <TwoInputs
            typeOne={"number"}
            typeTwo={"number"}
            placeOne={t('enterMobileNumber')}
            placeTwo={t('enterAge')}
           />
         </div>
        </Modal>
      </div>
    </div>
  );
}
export default Patients